// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"560b2fd7","487":"063f0207","578":"7e6a953f"}[chunkId] + ".chunk.js";
};